import React from "react"

export const Button = ({ label, action }) => {
    return (
        <button onClick={action} className="button" id="authorize_button">
            {label}
        </button>
    )
}
